import React from 'react';
import { Radio as BSRadio } from 'react-bootstrap';
import { useDirtyWarningContext, DirtyWarningInputProps } from '../DirtyWarning';

export interface RadioProps extends BSRadio.RadioProps, DirtyWarningInputProps {

}

export const Radio: React.FC<RadioProps> = (props) => {
   const context = useDirtyWarningContext();   
   const {disableDirtyTracking = false, onChange, ...otherProps} = props;

   const handleChange = (e: any) => {
      if (onChange) {
         onChange(e);
      }

      if (!disableDirtyTracking) {
         context.setDirty(true);
      }
   }

   return (
      <BSRadio onChange={handleChange} {...otherProps}>
         {props.children}
      </BSRadio>
   )
}

(Radio as any).displayName = 'Radio';